import { useState } from "react";
import gsap from "gsap";
import image_placeholder from "../../img/img_placeholder.svg";

const LazyImg = (props: any) => {
  let [loaded, setLoaded] = useState(false);
  let [imgSource, setImgSource] = useState(props.thumb);

  const imageLoadedHandler = () => {
    setTimeout(() => {
      setImgSource(props.src);
      setLoaded(true);
      gsap.to(".lazy-img", { webkitFilter: "blur(0px)" });
    }, 1000);
  };

  return (
    <img
      className={`lazy-img ${props.className}`}
      style={{
        ...props.style,
        filter: !loaded ? "blur(8px)" : "blur(8px)",
      }}
      onLoad={imageLoadedHandler}
      src={imgSource || image_placeholder}
      alt={props.alt}
    />
  );
};

export default LazyImg;
